import { render, staticRenderFns } from "./ChatView.vue?vue&type=template&id=57e31765&scoped=true"
import script from "./ChatView.vue?vue&type=script&lang=js"
export * from "./ChatView.vue?vue&type=script&lang=js"
import style0 from "./ChatView.vue?vue&type=style&index=0&id=57e31765&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e31765",
  null
  
)

export default component.exports